/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const REGISTER_SAGA = "app/REGISTER_SAGA";

export const LOGIN = "app/LOGIN";
export const LOGIN_SUCCESS = "app/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "app/LOGIN_FAILURE";

export const CHECK = "app/CHECK";
export const CHECK_SUCCESS = "app/CHECK_SUCCESS";
export const CHECK_FAILURE = "app/CHECK_FAILURE";

export const UPDATE_USER = "app/UPDATE_USER";
export const UPDATE_USER_SUCCESS = "app/UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "app/UPDATE_USER_FAILURE";

export const LOGOUT = "app/LOGOUT";
export const LOGOUT_SUCCESS = "app/LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "app/LOGOUT_FAILURE";

export const GOOGLE_INITIALIZED = "app/GOOGLE_INITIALIZED";

export const SENT_RESET_PASSWORD = "app/SENT_RESET_PASSWORD";
export const SENT_RESET_PASSWORD_SUCCESS = "app/SENT_RESET_PASSWORD_SUCCESS";
export const SENT_RESET_PASSWORD_FAILURE = "app/SENT_RESET_PASSWORD_FAILURE";
export const SENT_RESET_PASSWORD_PENDING = "app/SENT_RESET_PASSWORD_PENDING";

export const FORGOT_PASSWORD = "app/FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "app/FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "app/FORGOT_PASSWORD_FAILURE";

export const RESET_PASSWORD = "app/RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "app/RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "app/RESET_PASSWORD_FAILURE";

export const GET_USERDATA = "app/GET_USERDATA";
export const GET_USERDATA_SUCCESS = "app/GET_USERDATA_SUCCESS";
export const GET_USERDATA_FAILURE = "app/GET_USERDATA_FAILURE";

export const GET_SUBLIST = "app/GET_SUBLIST";
export const GET_SUBLIST_SUCCESS = "app/GET_SUBLIST_SUCCESS";
export const GET_SUBLIST_FAILURE = "app/GET_SUBLIST_FAILURE";

export const SET_PASSWORD = "app/SET_PASSWORD";
export const SET_PASSWORD_SUCCESS = "app/SET_PASSWORD_SUCCESS";
export const SET_PASSWORD_FAILURE = "app/SET_PASSWORD_FAILURE";

export const TOGGLE_MENU = "app/TOGGLE_MENU";

export const UPDATE_ALL_FEED_ACCESS = "app/UPDATE_ALL_FEED_ACCESS";
